import { render } from "./Categories.vue?vue&type=template&id=449e5236"
import script from "./Categories.vue?vue&type=script&lang=js"
export * from "./Categories.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/poshakjojomama-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__